module.exports = __webpack_public_path__ + "img/image5.3314262a.jpg";